<template>
  <div class="flex-1 flex flex-col justify-between">
    <Form class="space-y-6" @submit="editMetric">
      <div class="max-h-full h-full mt-4">
        <div class="flex relative items-center space-x-4">
          <div class="flex-1 min-w-0">
            <div class="w-full gap-2 flex flex-col">
              <div class="w-full flex flex-col gap-1">
                <div class="flex w-full justify-start items-center gap-2 mb-2">
                  <TextInput
                    name="option"
                    :value="option"
                    label=""
                    :classes="'w-full'"
                    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                    type="text"
                    :placeholder="$t('Type the option than click Add')" />

                  <!-- <input
                    v-model="option"
                    name="option"
                    type="text"
                    placeholder="Type the option than click Add"
                    classes=""
                    class="w-3/4 appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"> -->
                  <button class="primary-btn w-1/4" @click.prevent="addOption">{{ $t("Add") }}</button>
                </div>
                <div v-if="options.length > 0">
                  <ul>
                    <li v-for="(item, index) in options" :key="index" class="ml-2 sm:text-sm">
                      {{ item }}
                      <span class="absolute right-[85%] text-red-400 cursor-pointer" @click="removeOption(index)">{{ $t("Remove") }}</span>
                    </li>
                  </ul>
                </div>
                <div>{{ selected_options }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-2 w-full flex-row justify-between">
        <button type="button" class="cancel-btn w-1/2 m-0" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
        <button type="submit" class="primary-btn w-1/2">{{ $t("Update") }}</button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate"
import dataService from "@/services/data.service"

import TextInput from "@/components/shared/TextInput.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
export default {
  components: {
    Form,
    TextInput
  },
  props: {
    metric: {
      type: Object,
      required: false
    }
  },

  emits: ["cancel", "submitted", "done"],

  data() {
    return {
      options: [],
      option: "",
      selected_options: []
    }
  },
  watch: {},
  created() {
    this.options = this.metric.formula.slice(1)
    this.selected_options = this.metric.value.split(",")
  },
  methods: {
    addOption() {
      if (this.option != null && this.option != " ") {
        this.options.push(this.option)
      }
      this.option = null
    },
    removeOption(i) {
      this.selected_options = this.selected_options.filter((o) => o !== this.options[i])
      this.options.splice(i, 1)
    },
    editMetric() {
      const metric_obj = { ...this.metric, formula: [this.metric.formula[0]].concat(this.options), value: this.selected_options.join(",") }

      dataService.updateOrganizationMetric(metric_obj).then(() => {
        this.$store.dispatch("data/getMetrics")
        this.$emitter.emit(ALL_EMITTERS.LIST_METRICS_CHANGED, { metric_obj })
        this.$emit("done")
      })
    }
  }
}
</script>
